import { Md5 } from 'ts-md5';

export function generateMd5Hash(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  obj: any
): string | Int32Array {
  const objAsString = JSON.stringify(obj);
  return Md5.hashStr(objAsString);
}
